import {InviteDeviceType} from '../../../_contracts/InviteContracts';
import {AgentGuidanceItem} from '../../components/guidance-progress/GuidanceProgress';
import {MeetingMode} from '@techsee/techsee-common/lib/constants/room.constants';
import {isScreenOrAppMirroring, buildWaitingGuidanceItems} from '../_Shared';

/**
 * Get guidance items for email step based on client state
 */
export function getEmailGuidanceItems(
    deviceType: InviteDeviceType,
    isClientRedirectedToStore: boolean,
    translate: (key: string) => string,
    meetingMode?: MeetingMode,
    isNativeFullAssist?: boolean
): AgentGuidanceItem[] {
    if (isClientRedirectedToStore) {
        if (isNativeFullAssist) {
            return buildWaitingGuidanceItems('wifi-analysis-waiting', deviceType, translate, true);
        }

        if (isScreenOrAppMirroring(meetingMode)) {
            return buildWaitingGuidanceItems('screen-mirroring-waiting', deviceType, translate, true);
        }
    }

    return getDefaultEmailGuidanceItems(deviceType, translate);
}

/**
 * Default email guidance items (when client is not redirected to store)
 */
function getDefaultEmailGuidanceItems(
    deviceType: InviteDeviceType,
    translate: (key: string) => string
): AgentGuidanceItem[] {
    return [
        {
            stepType: 'email',
            stepNum: 1,
            stepText: translate('REACT.EMAIL.VIEW.NOTIFICATION'),
            deviceType,
            tooltipPosition: {
                bottom: '60%',
                left: '-37%'
            }
        },
        {
            stepType: 'email',
            stepNum: 2,
            stepText: translate('REACT.SMS.WAITING_FOR_CLIENT_ANDROID_INSTRUCTION_ONE'),
            deviceType,
            tooltipPosition: {
                bottom: '47%',
                left: '19%'
            }
        }
    ];
}
